import React, { useEffect, useState, useRef } from "react";
import api from "../../utils/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css";
import he from "he";
import parse from "html-react-parser";
import { Button, Spinner, Modal } from "react-bootstrap";
import {
  FiSearch,
  FiFilter,
  FiPlus,
  FiDownload,
  FiEye,
  FiEyeOff,
  FiCheck,
  FiX,
  FiTrash2,
  FiArrowLeft,
  FiBook,
  FiCheckCircle,
  FiXCircle,
  FiClipboard,
  FiBookOpen,
  FiChevronRight,
  FiHome
} from 'react-icons/fi';
import "./PickQuestions.css";

const PickQuestions = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [questions, setQuestions] = useState([]);
  const [sections, setSections] = useState([]);
  const [selectedSection, setSelectedSection] = useState(1);
  const [pickedQuestions, setPickedQuestions] = useState([]);
  const [subjectMap, setSubjectMap] = useState({});
  const [selectedChapter, setSelectedChapter] = useState("");
  const [selectedTopic, setSelectedTopic] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedQuestionType, setSelectedQuestionType] = useState("");
  const [selectedExamType, setSelectedExamType] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [chapters, setChapters] = useState([]);
  const [topics, setTopics] = useState([]);
  const [levels, setLevels] = useState([]);
  const [questionType, setQuestionType] = useState([]);
  const [examType, setExamType] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [examTypeFilter, setExamTypeFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [selectedQuestionIds, setSelectedQuestionIds] = useState(new Set());
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [showPreview, setShowPreview] = useState(false);
  const [pickedLoaded, setPickedLoaded] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [questionToDelete, setQuestionToDelete] = useState(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const init = async () => {
      await fetchTemplateDetails();
      await initializePickedQuestions();
    };
    init();
  }, []);

  useEffect(() => {
    if (!pickedLoaded) return;
    fetchData(currentPage);
  }, [
    pickedLoaded,
    currentPage,
    selectedSubject,
    selectedChapter,
    selectedTopic,
    selectedExamType,
    selectedLevel,
    selectedQuestionType,
    searchQuery,
  ]);

  const createPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

  const handlePageChange = (page) => {
    if (page === "...") return;
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  async function fetchTemplateDetails() {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "getTemplateDetailsInAddQuestions";

    const fd = new FormData();
    fd.append("programType", programType);
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);
    fd.append("id", id);

    try {
      const response = await api.post("paper/paperCurl", fd);
      const templateDetails = JSON.parse(response.data.data[0].details);

      if (templateDetails?.sections) {
        const sectionsArray = Object.values(templateDetails.sections);
        setSections(sectionsArray);

        const tempMap = {};
        sectionsArray.forEach((section) => {
          const subjects = section.subjects;
          if (subjects && typeof subjects === "object") {
            Object.values(subjects).forEach((subject) => {
              tempMap[subject.subjectId] = subject.subjectName;
            });
          }
        });
        setSubjectMap(tempMap);

        const defaultSection = sectionsArray.find((s) => s.sectionNumber === 1);
        if (defaultSection) {
          setSelectedSection(defaultSection.sectionNumber);
          setSelectedQuestionType(defaultSection.questionType);
        }
      }
    } catch (error) {
      console.error("Error fetching template details:", error);
    }
  }

  const fetchData = async (page = 1) => {
    try {
      setLoading(true);
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getQuestionDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("paperId", id);
      fd.append("page", page);
      fd.append("itemsPerPage", 30);
      fd.append("limit", 30);

      if (selectedSubject) fd.append("subject", selectedSubject);
      if (selectedChapter) fd.append("chapter", selectedChapter);
      if (selectedTopic) fd.append("topic", selectedTopic);
      if (examTypeFilter) fd.append("examType", examTypeFilter);
      if (selectedLevel) fd.append("level", selectedLevel);
      if (selectedQuestionType) fd.append("questionType", selectedQuestionType);
      if (searchQuery) fd.append("search", searchQuery);

      const response = await api.post("question/questionCurl", fd);
      console.log("res", response)
      const {
        questions: fetchedQuestions,
        currentPage: pageFromAPI,
        totalPages: totalFromAPI,
      } = response.data;

      const pickedIdSet = new Set(
        pickedQuestions.map((q) => String(q.questionId))
      );

      const mergedQuestions = (fetchedQuestions || []).map((q) => ({
        ...q,
        isPicked: pickedIdSet.has(String(q.id)),
      }));

      setQuestions(mergedQuestions);
      setTotalPages(totalFromAPI || 1);
      setInitialLoading(false);

      if (pageFromAPI && pageFromAPI !== currentPage) {
        setCurrentPage(pageFromAPI);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setLoading(false);
    }
  };

  async function fetchAnswers(questionId) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getOptionsAndAnsForQuestion";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("questionId", questionId);

      const response = await api.post("question/questionCurl", fd);
      return response.data;
    } catch (error) {
      console.error("Error fetching answers:", error);
      return null;
    }
  }

  const renderLatexText = (text, layout = "single", fontSize = "16px") => {
    if (!text) return null;
    let decodedText = he.decode(text);
    decodedText = decodedText.replace(/<br\s*\/?>/gi, "\n");

    const latexAndImageRegex =
      /\\\((.*?)\\\)|\\\[(.*?)\\\]|<img[^>]*\bsrc=(["'])(.*?)\3[^>]*>|\\begin{align}([\s\S]*?)\\end{align}/g;

    const parts = [];
    let lastIndex = 0;
    let match;
    let key = 0;

    while ((match = latexAndImageRegex.exec(decodedText)) !== null) {
      const [fullMatch, inlineLatex, blockLatex, , imageSrc, alignContent] = match;
      const matchIndex = match.index;

      if (matchIndex > lastIndex) {
        const plainText = decodedText.slice(lastIndex, matchIndex);
        plainText.split("\n").forEach((line, i, arr) => {
          if (line) parts.push(<span key={`html-${key++}`}>{parse(line)}</span>);
          if (i < arr.length - 1) parts.push(<br key={`br-${key++}`} />);
        });
      }

      if (imageSrc) {
        parts.push(
          <img
            key={`img-${key++}`}
            src={imageSrc}
            alt="Image"
            style={{
              maxWidth: `calc(${fontSize} * 18)`,
              display: "inline",
              verticalAlign: "middle",
              marginLeft: "4px",
              marginRight: "4px",
            }}
          />
        );
      } else if (alignContent) {
        parts.push(
          <BlockMath key={`align-${key++}`}>
            {`\\begin{align}${alignContent}\\end{align}`}
          </BlockMath>
        );
      } else if (inlineLatex || blockLatex) {
        parts.push(
          <InlineMath key={`inline-${key++}`}>
            {inlineLatex || blockLatex}
          </InlineMath>
        );
      }

      lastIndex = matchIndex + fullMatch.length;
    }

    if (lastIndex < decodedText.length) {
      const remaining = decodedText.slice(lastIndex);
      remaining.split("\n").forEach((line, i, arr) => {
        if (line)
          parts.push(
            <span className="normal-inline" key={`html-${key++}`}>
              {parse(line)}
            </span>
          );
        if (i < arr.length - 1) parts.push(<br key={`br-${key++}`} />);
      });
    }

    return (
      <span style={{ whiteSpace: "normal", display: "inline" }}>{parts}</span>
    );
  };

  const initializePickedQuestions = async () => {
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");

    try {
      const fd = new FormData();
      fd.append("programType", "getSelectedQUestionInPaper");
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("paperId", id);

      const response = await api.post("picQuestion/picQuestionCurl", fd);

      console.log("ddd", response)
      const picked = response.data;

      if (Array.isArray(picked)) {
        const enrichedPicked = picked.map((p) => {
          const q = questions.find(
            (q) => String(q.id) === String(p.questionId)
          );
          return {
            ...p,
            questionText: q?.question || "",
          };
        });

        setPickedQuestions(enrichedPicked);
        const pickedIds = picked.map((item) => String(item.questionId));
        setQuestions((prevQuestions) =>
          prevQuestions.map((q) => ({
            ...q,
            isPicked: pickedIds.includes(String(q.id)),
          }))
        );
      }
      setPickedLoaded(true);
    } catch (error) {
      console.error("Error initializing picked questions:", error);
    }
  };

  const getPickedStats = () => {
    const pickedStats = {};
    pickedQuestions.forEach(({ sectionId, subjectId }) => {
      if (!pickedStats[sectionId]) pickedStats[sectionId] = {};
      if (!pickedStats[sectionId][subjectId])
        pickedStats[sectionId][subjectId] = 0;
      pickedStats[sectionId][subjectId]++;
    });

    const totalStats = {};
    sections.forEach((section) => {
      const sectionNumber = section.sectionNumber;
      if (!totalStats[sectionNumber]) totalStats[sectionNumber] = {};

      if (section.subjects && typeof section.subjects === "object") {
        Object.values(section.subjects).forEach((subject) => {
          totalStats[sectionNumber][subject.subjectId] = Number(
            subject.noOfQuestions || 0
          );
        });
      }
    });

    return { picked: pickedStats, total: totalStats };
  };

  const handleTogglePick = async (index, questionId, isCurrentlyPicked) => {
    if (!selectedSection) {
      toast.error("Please select a section before picking a question.");
      return;
    }

    const updated = [...questions];

    try {
      const programType = isCurrentlyPicked ? "removeQuestion" : "addQuestion";
      const fd = new FormData();
      fd.append("programType", programType);
      fd.append("loggedInUser", localStorage.getItem("loggedInUser"));
      fd.append("token", localStorage.getItem("authToken"));
      fd.append("paperId", id);
      fd.append("questionId", questionId);
      fd.append("section", selectedSection);

      const response = await api.post("picQuestion/picQuestionCurl", fd);
      console.log("rr", response
      )
      const res = response.data;

      if (res.status === false) {
        toast[res.type === "warning" ? "warning" : "error"](
          res.data || "Something went wrong"
        );
      } else {
        updated[index].isPicked = !isCurrentlyPicked;
        setQuestions(updated);
        toast.success(res.data || "Updated successfully");

        setPickedQuestions((prev) => {
          if (isCurrentlyPicked) {
            return prev.filter((q) => String(q.questionId) !== String(questionId));
          }

          const q = updated[index];

          return [
            ...prev,
            {
              questionId: String(questionId),
              sectionId: Number(selectedSection),
              subjectId: String(q.subjectId),
            },
          ];
        });

      }
    } catch (error) {
      console.error("Error toggling question pick:", error);
      toast.error("Something went wrong while toggling pick");
    }
  };

  const handleRemoveFromPreview = async (questionId) => {
    try {
      const fd = new FormData();
      fd.append("programType", "removeQuestion");
      fd.append("loggedInUser", localStorage.getItem("loggedInUser"));
      fd.append("token", localStorage.getItem("authToken"));
      fd.append("paperId", id);
      fd.append("questionId", questionId);

      const res = await api.post("picQuestion/picQuestionCurl", fd);

      if (res.data?.status) {
        toast.success("Question removed");
        setPickedQuestions((prev) =>
          prev.filter((q) => String(q.questionId) !== String(questionId))
        );

        setQuestions((prev) =>
          prev.map((q) =>
            q.id === questionId ? { ...q, isPicked: false } : q
          )
        );
      } else {
        toast.error(res.data?.data || "Failed to remove");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error removing question");
    }
  };

  useEffect(() => {
    fetchSubjects();
    fetchChapters();
    fetchQuestionType();
    fetchLevel();
  }, []);

  async function fetchSubjects() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const storedSubjectIds =
        JSON.parse(localStorage.getItem("selectedSubjects")) || [];

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getSubjectOnChange");
      fd.append("role", role);

      const subjectResponse = await api.post("onchange/onchangeCurl", fd);

      if (Array.isArray(subjectResponse.data.data)) {
        const filteredSubjects = subjectResponse.data.data.filter((subject) =>
          storedSubjectIds.map(String).includes(String(subject.id))
        );
        setSubjects(filteredSubjects);
      } else {
        setSubjects([]);
      }
    } catch (error) {
      console.error("Error fetching subjects:", error);
      setSubjects([]);
    }
  }

  async function fetchChapters(subjectId) {
    if (!subjectId) {
      setChapters([]);
      return;
    }

    try {
      const fd = new FormData();
      fd.append("loggedInUser", localStorage.getItem("loggedInUser"));
      fd.append("token", localStorage.getItem("authToken"));
      fd.append("programType", "getChapterOnChangeMultiple");
      fd.append("subjectId[]", subjectId);

      const chapterResponse = await api.post("onchange/onchangeCurl", fd);

      if (Array.isArray(chapterResponse.data.data)) {
        const storedChapterIds =
          JSON.parse(localStorage.getItem("selectedChapters")) || [];

        const finalChapters =
          storedChapterIds.length > 0
            ? chapterResponse.data.data.filter((chapter) =>
              storedChapterIds.map(String).includes(String(chapter.id))
            )
            : [];

        setChapters(finalChapters);
      } else {
        setChapters([]);
      }
    } catch (error) {
      console.error("Error fetching chapters:", error);
      setChapters([]);
    }
  }

  async function fetchTopics(chapterId) {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getTopicOnChangeMultiple";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);
      fd.append("paperId", id);
      fd.append("chapterId[]", chapterId);

      const response = await api.post("onchange/onchangeCurl", fd);

      if (Array.isArray(response.data.data)) {
        setTopics(response.data.data);
      } else {
        console.warn("Unexpected API response format", response);
        setTopics([]);
      }
    } catch (error) {
      console.error("Error fetching topics:", error);
      setTopics([]);
    }
  }

  useEffect(() => {
    if (selectedChapter) {
      fetchTopics(selectedChapter);
    } else {
      setSelectedTopic("");
    }
  }, [selectedChapter]);

  async function fetchLevel() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getLevelDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("level/levelCurl", fd);

      if (Array.isArray(response.data.getLevelDetails)) {
        setLevels(response.data.getLevelDetails);
      } else {
        setLevels([]);
      }
    } catch (error) {
      setLevels([]);
    }
  }

  async function fetchQuestionType() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getQuestionTypeDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("questionType/questionTypeCurl", fd);

      if (Array.isArray(response.data.getQuestionTypeDetails)) {
        setQuestionType(response.data.getQuestionTypeDetails);
      } else {
        setQuestionType([]);
      }
    } catch (error) {
      setQuestionType([]);
    }
  }

  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchClick = () => {
    setCurrentPage(1);
    fetchData(1);
  };

  const handleSelectAllQuestions = async () => {
    try {
      const currentPageQuestionIds = questions
        .filter((q) => q.subjectId !== undefined)
        .map((q) => q.id);

      setSelectedQuestionIds((prev) => {
        const updatedSet = new Set([...prev, ...currentPageQuestionIds]);
        return updatedSet;
      });

      setSelectAll(true);
      toast.success("Current page questions selected.");
    } catch (err) {
      console.error("Select All Error:", err);
      toast.error("Failed to select questions.");
    }
  };

  const handleDeselectAllQuestions = () => {
    const currentPageQuestionIds = questions
      .filter((q) => q.subjectId !== undefined)
      .map((q) => q.id);

    setSelectedQuestionIds((prev) => {
      const updatedSet = new Set([...prev]);
      currentPageQuestionIds.forEach((id) => updatedSet.delete(id));
      return updatedSet;
    });

    setSelectAll(false);
    toast.info("Current page questions deselected.");
  };

  useEffect(() => {
    const currentPageIds = questions
      .filter((q) => q.subjectId !== undefined)
      .map((q) => q.id);

    const allSelected = currentPageIds.every((id) =>
      selectedQuestionIds.has(id)
    );

    setSelectAll(allSelected);
  }, [selectedQuestionIds, questions]);

  const handlePickSelectedQuestions = async () => {
    const selectedIdsArray = Array.from(selectedQuestionIds);
    // console.log("Selected Question IDs:", selectedIdsArray);

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "addQuestionMultiple");
      fd.append("paperId", id);
      fd.append("section", selectedSection);

      selectedIdsArray.forEach((qid) => {
        fd.append("questionId[]", qid);
      });

      const response = await api.post("picQuestion/picQuestionCurl", fd);

      console.log("rrrrrrrrrrrrrrrrrrrrrrrr", response)
      const result = response?.data;

      if (result?.status === true && result?.type === "success") {
        console.log("rrrrrrrrrrrrrrrrrrrrrrrr1111111111", response)
        toast.success(response.data?.data);

        setSelectedQuestionIds(new Set());
        setSelectAll(false);

        const selectedIdSet = new Set(selectedIdsArray.map((id) => String(id)));

        setQuestions((prevQuestions) =>
          prevQuestions.map((q) =>
            selectedIdSet.has(String(q.id)) ? { ...q, isPicked: true } : q
          )
        );

        setPickedQuestions((prev) => {
          const newPicks = selectedIdsArray.map((qid) => {
            const q = questions.find((q) => String(q.id) === String(qid));
            return {
              questionId: qid,
              sectionId: selectedSection,
              subjectId: q?.subjectId || "",
            };
          });

          const uniquePicks = [
            ...prev.filter((p) => !selectedIdsArray.includes(p.questionId)),
            ...newPicks,
          ];

          return uniquePicks;
        });

        await initializePickedQuestions();
        await fetchTemplateDetails();
      } else {
        const errorMessage =
          result?.data ||
          result?.message 

        const errorType = result?.type || "error";

        toast[errorType === "warning" ? "warning" : "error"](errorMessage);
      }
    } catch (error) {
      console.error("Error adding questions:", error);
      toast.error("Something went wrong while adding questions.");
    }
  };

  const shouldUseSingleColumn = (options = []) => {
    return options.some((opt) => {
      const text = typeof opt === "string" ? opt : opt?.option || opt?.value || opt?.text || "";
      return text.length > 50;
    });
  };


  const pickedStatsMemo = React.useMemo(() => {
    return getPickedStats();
  }, [pickedQuestions, sections]);

  const { picked, total } = pickedStatsMemo;

const formatDateTime = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr.replace(" ", "T"));

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",   // 👈 added
    hour12: true,
  });
};


  return (
    <div className="pick-questions-container">
      <ToastContainer />



      {/* Header */}
      {/* <div className="pick-questions-header">
        <div className="header-content">
          <h1>📝 Pick Questions</h1>
          <p>Select questions for your paper from the question bank</p>
        </div>
        
     
        <div className="breadcrumb">
          <ul className="breadcrumb-list">
            <li>
              <Link to="/" className="breadcrumb-item">
                <FiHome size={14} />
                <span>Home</span>
              </Link>
              <FiChevronRight className="breadcrumb-separator" />
            </li>
            <li>
              <span className="breadcrumb-item active">
                Pick Questions
              </span>
            </li>
          </ul>
        </div>
      </div> */}

      {/* Main Content Grid */}
      <div className="pick-questions-content-grid">
        {/* Filters Sidebar */}
        <div className={`filters-sidebar ${showFilters ? "show" : ""}`}>
          <div className="filters-card">
            <div className="filters-header">
              <h3><FiFilter /> Filters</h3>
              <button className="close-filters" onClick={() => setShowFilters(false)}>×</button>
            </div>

            <div className="filters-content">
              {/* Section Selection */}
              <div className="filter-group">
                <label>Select Section</label>
                <div className="section-buttons">
                  {sections.map((section) => (
                    <button
                      key={section.sectionNumber}
                      className={`section-button ${selectedSection === section.sectionNumber ? "active" : ""}`}
                      onClick={() => {
                        setSelectedSection(section.sectionNumber);
                        setSelectedQuestionType(section.questionType);
                        setCurrentPage(1);
                      }}
                    >
                      Section {section.sectionNumber}
                    </button>
                  ))}
                </div>
              </div>

              {/* Stats Card */}
              <div className="stats-card">
                <h4>📊 Picked Questions</h4>

                {sections.map((section) => {
                  const sectionNo = section.sectionNumber;

                  const sectionTotal = Object.values(total[sectionNo] || {}).reduce(
                    (sum, count) => sum + Number(count),
                    0
                  );

                  const pickedTotal = Object.values(picked[sectionNo] || {}).reduce(
                    (sum, count) => sum + Number(count),
                    0
                  );

                  return (
                    <div key={sectionNo} className="section-stats">
                      <div
                        className="section-header"
                        style={{ display: "flex", justifyContent: "space-between" }}
                      >
                        <span className="section-title">
                          Section {sectionNo}
                        </span>
                        <span className="section-title">
                          {pickedTotal} / {sectionTotal}
                        </span>
                      </div>


                      {/* ===== SUBJECTS (ONLY PICKED ONES) ===== */}
                      {/* ===== SUBJECTS (SHOW ALL, PICKED OR NOT) ===== */}
                      {total[sectionNo] &&
                        Object.entries(total[sectionNo]).map(
                          ([subjectId, totalCount]) => {
                            const pickedCount =
                              picked[sectionNo]?.[subjectId] || 0;

                            return (
                              <div key={subjectId} className="subject-stats">
                                <span className="subject-name">
                                  {subjectMap[subjectId]}
                                </span>
                                <span className="subject-count">
                                  {pickedCount}
                                </span>
                              </div>
                            );
                          }
                        )}

                    </div>
                  );
                })}
              </div>

              {/* Other Filters */}
              <div className="filter-group">
                <label>Subject</label>
                <select
                  className="filter-select"
                  value={selectedSubject}
                  onChange={async (e) => {
                    const subjectId = e.target.value;
                    setSelectedSubject(subjectId);
                    setSelectedChapter("");
                    setSelectedTopic("");
                    setChapters([]);
                    setTopics([]);
                    if (subjectId) {
                      await fetchChapters(subjectId);
                    }
                  }}
                >
                  <option value="">Select Subject</option>
                  {subjects.map((subject) => (
                    <option key={subject.id} value={subject.id}>
                      {subject.subjectName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-group">
                <label>Chapter</label>
                <select
                  className="filter-select"
                  value={selectedChapter}
                  onChange={(e) => {
                    const chapterId = e.target.value;
                    setSelectedChapter(chapterId);
                    setSelectedTopic("");
                    setTopics([]);
                    if (chapterId) {
                      fetchTopics(chapterId);
                    }
                  }}
                >
                  <option value="">Select Chapter</option>
                  {chapters.map((chapter) => (
                    <option key={chapter.id} value={chapter.id}>
                      {chapter.chapterName} ({chapter.chapterCount})
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-group">
                <label>Topic</label>
                <select
                  className="filter-select"
                  value={selectedTopic}
                  onChange={(e) => setSelectedTopic(e.target.value)}
                >
                  <option value="">Select Topic</option>
                  {topics.map((topic) => (
                    <option key={topic.id} value={topic.id}>
                      {topic.topicName} ({topic.topicCount})
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-group">
                <label>Exam Type</label>
                <input
                  type="text"
                  className="filter-input"
                  placeholder="Filter by Exam Type"
                  value={examTypeFilter}
                  onChange={(e) => setExamTypeFilter(e.target.value.trim())}
                />
              </div>

              <div className="filter-group">
                <label>Level</label>
                <select
                  className="filter-select"
                  value={selectedLevel}
                  onChange={(e) => setSelectedLevel(e.target.value)}
                >
                  <option value="">Select Level</option>
                  {levels.map((level) => (
                    <option key={level.id} value={level.id}>{level.levelName}</option>
                  ))}
                </select>
              </div>

              <div className="filter-group">
                <label>Question Type</label>
                <select
                  className="filter-select"
                  value={selectedQuestionType}
                  onChange={(e) => setSelectedQuestionType(e.target.value)}
                >
                  <option value="">Select Type</option>
                  {questionType.map((questionType) => (
                    <option key={questionType.id} value={questionType.id}>
                      {questionType.questionType}
                    </option>
                  ))}
                </select>
              </div>

              <div className="filter-buttons">
                <button
                  className="filter-btn primary"
                  onClick={() => {
                    setCurrentPage(1);
                    fetchData(1);
                  }}
                >
                  Apply Filters
                </button>
                <button
                  className="filter-btn secondary"
                  onClick={() => {
                    setSelectedSubject("");
                    setSelectedChapter("");
                    setSelectedTopic("");
                    setExamTypeFilter("");
                    setSelectedLevel("");
                    setSelectedQuestionType("");
                    setSearchQuery("");
                    setCurrentPage(1);
                    fetchData(1);
                  }}
                >
                  Reset All
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="questions-main">
          {/* Toolbar */}
          {/* Toolbar */}
          <div className="questions-toolbar">
            {/* Mobile filter toggle */}
            <button className="filter-toggle" onClick={() => setShowFilters(!showFilters)}>
              <FiFilter /> Filters
            </button>

            {/* All controls in one row */}
            <div className="toolbar-controls">
              {/* Search */}
              <div className="search-container">
                <FiSearch className="search-icon" />
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search by Question ID..."
                  value={searchQuery}
                  onChange={handleInputChange}
                  onKeyDown={(e) => e.key === "Enter" && handleSearchClick()}
                />
                <button className="search-button" onClick={handleSearchClick}>
                  Search
                </button>
              </div>

              {/* Action buttons */}
              <div className="toolbar-actions">
                {/* Add Chapters button */}
                <button
                  className="action-button secondary"
                  onClick={() => navigate(-1)}
                >
                  <FiPlus /> Add Chapters
                </button>

                {/* Import button */}
                <button
                  className="action-button warning"
                  onClick={() => navigate("/import-question")}
                >
                  <FiDownload /> Import
                </button>

                {/* Preview button */}
                {pickedQuestions.length > 0 && (
                  <button
                    className="action-button info"
                    onClick={() => setShowPreview(true)}
                  >
                    <FiClipboard /> Preview ({pickedQuestions.length})
                  </button>
                )}

                {/* Select All/Deselect All */}
                <button
                  className="action-button select-all"
                  onClick={selectAll ? handleDeselectAllQuestions : handleSelectAllQuestions}
                >
                  {selectAll ? <FiXCircle /> : <FiCheckCircle />}
                  {selectAll ? "Deselect All" : "Select All"}
                </button>

                {/* Pick Selected button */}
                {selectedQuestionIds.size > 0 && (
                  <button
                    className="action-button success"
                    onClick={handlePickSelectedQuestions}
                  >
                    <FiCheck /> Pick ({selectedQuestionIds.size})
                  </button>
                )}

                {/* Review Paper button */}
                <Link to={`/view-questions/${id}`} className="action-button view-paper">
                  <FiBookOpen /> Review
                </Link>
              </div>
            </div>
          </div>

          {/* Questions List */}
          <div className="questions-list">
            {initialLoading ? (
              <div className="loading-state">
                <div className="loading-spinner"></div>
                <p>Loading questions...</p>
              </div>
            ) : questions.length === 0 ? (
              <div className="empty-state">
                <FiBook size={48} />
                <h3>No Questions Found</h3>
                <p>Try adjusting your filters or search criteria</p>
              </div>
            ) : (
              <>
                {questions.map((question, index) => (
                  <div
                    key={question.id}
                    className={`question-card ${question.isPicked ? "picked" : ""}`}
                  >
                    <div className="question-header">
                      <div className="question-info">
                        <div className="question-number">
                          Q{(currentPage - 1) * 30 + index + 1}
                        </div>
                        <div className="question-id">ID: {question.id}</div>
                        <div className="question-tags">
                          {question.levelName && (
                            <span className="tag level">{question.levelName}</span>
                          )}
                          {question.examType && (
                            <span className="tag exam-type" dangerouslySetInnerHTML={{ __html: question.examType }} />
                          )}
                          <span className="tag status">
                            {question.isPicked ? "✅ Picked" : "📝 Available"}
                          </span>
                        </div>
                      </div>
                      <div className="question-actions">
                        <input
                          type="checkbox"
                          className="question-checkbox"
                          checked={selectedQuestionIds.has(question.id)}
                          onChange={() => {
                            const updated = new Set(selectedQuestionIds);
                            if (updated.has(question.id)) {
                              updated.delete(question.id);
                            } else {
                              updated.add(question.id);
                            }
                            setSelectedQuestionIds(updated);
                          }}
                        />
                        <button
                          className={`action-icon ${question.isPicked ? "remove" : "pick"}`}
                          onClick={() =>
                            handleTogglePick(index, question.id, question.isPicked)
                          }
                        >
                          {question.isPicked ? <FiX size={14} /> : <FiCheck size={14} />}
                          {question.isPicked ? "Remove" : "Pick"}
                        </button>
                      </div>
                    </div>

                    <div className="question-content">
                      {renderLatexText(question.question)}
                    </div>

                    {question.options?.length > 0 && (
                      <div className="options-section">
                        <div className="options-header">Options</div>
                        <div
                          className="options-grid"
                          style={{
                            gridTemplateColumns: shouldUseSingleColumn(question.options)
                              ? "1fr"
                              : "1fr 1fr",
                          }}
                        >
                          {question.options.map((option, i) => (
                            <div key={i} className="option-item">
                              <div className="option-letter">{i + 1}</div>
                              <div className="option-text">
                                {renderLatexText(option)}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="question-footer">
                      <button
                        className="toggle-answer"
                        onClick={async () => {
                          const updated = [...questions];
                          if (!updated[index].showAnswer) {
                            const data = await fetchAnswers(question.id);
                            if (data) {
                              updated[index] = {
                                ...updated[index],
                                options: data.options || [],
                                answer: data.answer || "",
                                explanation: data.explanation || "",
                                optionId: data.optionId || "",
                              };
                            }
                          }
                          updated[index].showAnswer = !updated[index].showAnswer;
                          setQuestions(updated);
                        }}
                      >
                        {question.showAnswer ? (
                          <>
                            <FiEyeOff /> Hide Details
                          </>
                        ) : (
                          <>
                            <FiEye /> Show Details
                          </>
                        )}
                      </button>
                    </div>

                    {question.showAnswer && (
                      <div className="answer-section">
                        <div className="answer-divider"></div>
                        <div className="answer-content">
                          <div className="answer-field">
                            <strong>Explanation:</strong>
                            <div className="answer-text">{renderLatexText(question.explanation)}</div>
                          </div>
                          {question.answer && (
                            <div className="answer-field">
                              <strong>Answer:</strong>
                              <div className="answer-text">
                                {renderLatexText(question.answer)}
                                <span className="option-id"> (Option {question.optionId})</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ))}

                {questions.length > 0 && (
                  <div className="pagination-container">
                    <div className="pagination">
                      {createPagination().map((pageNum, index) => (
                        <button
                          key={index}
                          className={`pagination-button ${currentPage === pageNum ? "active" : ""}`}
                          onClick={() => handlePageChange(pageNum)}
                          disabled={pageNum === "..."}
                        >
                          {pageNum}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Preview Modal */}
      {showPreview && (
        <div className="modal-overlay" onClick={() => setShowPreview(false)}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>📋 Picked Questions Preview</h3>
              <button className="modal-close" onClick={() => setShowPreview(false)}>×</button>
            </div>

            <div className="modal-content">
              {pickedQuestions.length === 0 ? (
                <div className="empty-modal">
                  <FiBook size={32} />
                  <p>No questions picked yet</p>
                </div>
              ) : (
                <div className="preview-list">
                  {pickedQuestions.map((pq, index) => (
                    <div key={pq.questionId} className="preview-item">
                      <div className="preview-content">
                       <div className="preview-header">
  <span className="preview-number">Q{index + 1}</span>
  <span className="preview-id">ID: {pq.questionId}</span>
  <span className="preview-section">Section {pq.sectionId}</span>

  {pq.created_at && (
    <span className="preview-date">
      🕒 {formatDateTime(pq.created_at)}
    </span>
  )}
</div>

                        <div className="preview-text">
                          {renderLatexText(pq.question)}
                        </div>
                      </div>
                      <button
                        className="preview-remove"
                        onClick={() => handleRemoveFromPreview(pq.questionId)}
                      >
                        <FiTrash2 size={14} />
                        Remove
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button
                className="modal-button secondary"
                onClick={() => setShowPreview(false)}
              >
                Close
              </button>
              <button
                className="modal-button primary"
                onClick={() => {
                  setShowPreview(false);
                  navigate(`/view-questions/${id}`);
                }}
              >
                Review Complete Paper
              </button>
            </div>
          </div>
        </div>
      )}

      <style>
        {`
          .pick-questions-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
            padding: 1.5rem;
          }

          /* Header */
          .pick-questions-header {
            background: white;
            border-radius: 1rem;
            padding: 1.5rem;
            margin-bottom: 1.5rem;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
            border: 1px solid #e2e8f0;
          }
.preview-date {
  font-size: 0.75rem;
  color: #64748b;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 999px;
  font-weight: 500;
}

          .header-content h1 {
            font-size: 1.75rem;
            font-weight: 700;
            color: #1f2937;
            margin: 0 0 0.5rem;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          .header-content p {
            font-size: 0.875rem;
            color: #6b7280;
            margin: 0 0 1rem;
          }

          /* Breadcrumb */
          .breadcrumb {
            padding-top: 1rem;
            border-top: 1px solid #f3f4f6;
          }

          .breadcrumb-list {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .breadcrumb-list li {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .breadcrumb-item {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            color: #6b7280;
            text-decoration: none;
            font-size: 0.875rem;
            transition: color 0.2s;
          }

          .breadcrumb-item:hover {
            color: #3b82f6;
          }

          .breadcrumb-item.active {
            color: #1f2937;
            font-weight: 500;
          }

          .breadcrumb-separator {
            color: #9ca3af;
            width: 16px;
            height: 16px;
          }

          /* Content Grid */
          .pick-questions-content-grid {
            display: grid;
            grid-template-columns: 280px 1fr;
            gap: 1.5rem;
          }

          /* Filters Sidebar */
          .filters-sidebar {
            position: sticky;
            top: 1.5rem;
            height: fit-content;
          }

          .filters-card {
            background: white;
            border-radius: 1rem;
            border: 1px solid #e2e8f0;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
            overflow: hidden;
          }

          .filters-header {
            padding: 1.25rem;
            border-bottom: 1px solid #f3f4f6;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .filters-header h3 {
            font-size: 1rem;
            font-weight: 600;
            color: #1f2937;
            margin: 0;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .close-filters {
            display: none;
            background: none;
            border: none;
            font-size: 1.5rem;
            color: #9ca3af;
            cursor: pointer;
          }

          .filters-content {
            padding: 1.25rem;
            max-height: calc(100vh - 200px);
            overflow-y: auto;
          }

          /* Section Buttons */
          .section-buttons {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            margin-bottom: 1.5rem;
          }

          .section-button {
            padding: 0.75rem;
            border: 1px solid #e5e7eb;
            border-radius: 0.5rem;
            background: white;
            color: #374151;
            font-size: 0.875rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          }

          .section-button:hover {
            background: #f3f4f6;
          }

          .section-button.active {
            background: #3b82f6;
            color: white;
            border-color: #3b82f6;
          }

          /* Stats Card */
          .stats-card {
            background: #f8fafc;
            border-radius: 0.75rem;
            padding: 1rem;
            margin-bottom: 1.5rem;
            border: 1px solid #e2e8f0;
          }

          .stats-card h4 {
            font-size: 0.875rem;
            font-weight: 600;
            color: #374151;
            margin: 0 0 1rem;
          }

          .section-stats {
            margin-bottom: 0.75rem;
          }

          .section-title {
            font-size: 0.75rem;
            font-weight: 600;
            color: #6b7280;
            margin-bottom: 0.5rem;
          }

          .subject-stats {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0.5rem 0.75rem;
            background: white;
            border-radius: 0.5rem;
            margin-bottom: 0.5rem;
            border: 1px solid #f3f4f6;
          }

          .subject-name {
            font-size: 0.75rem;
            color: #374151;
          }

          .subject-count {
            font-size: 0.75rem;
            font-weight: 600;
            color: #3b82f6;
          }

          /* Filter Groups */
          .filter-group {
            margin-bottom: 1.25rem;
          }

          .filter-group label {
            display: block;
            font-size: 0.75rem;
            font-weight: 600;
            color: #374151;
            margin-bottom: 0.5rem;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .filter-select, .filter-input {
            width: 100%;
            padding: 0.625rem 0.875rem;
            border: 1px solid #e5e7eb;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            color: #374151;
            background: white;
            transition: border-color 0.2s;
          }

          .filter-select:focus, .filter-input:focus {
            outline: none;
            border-color: #3b82f6;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
          }

          .filter-buttons {
            display: flex;
            flex-direction: column;
            gap: 0.75rem;
            margin-top: 1.5rem;
          }

          .filter-btn {
            padding: 0.75rem;
            border: none;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
          }

          .filter-btn.primary {
            background: #3b82f6;
            color: white;
          }

          .filter-btn.primary:hover {
            background: #2563eb;
            transform: translateY(-1px);
          }

          .filter-btn.secondary {
            background: #f3f4f6;
            color: #374151;
            border: 1px solid #e5e7eb;
          }

          .filter-btn.secondary:hover {
            background: #e5e7eb;
          }

          /* Questions Main */
          .questions-main {
            display: flex;
            flex-direction: column;
            gap: 1.5rem;
          }

          /* Toolbar */
       .questions-toolbar {
  background: white;
  border-radius: 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  gap: 1rem;
}

.filter-toggle {
  display: none;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

          .toolbar-left {
            display: flex;
            align-items: center;
            gap: 1rem;
            flex: 1;
          }

         .toolbar-controls {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}


          .filter-toggle:hover {
            background: #e5e7eb;
          }

   .search-container {
  display: flex;
  align-items: center;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  overflow: hidden;
  flex: 1;
  min-width: 200px;
  max-width: 400px;
}

.search-icon {
  padding: 0.75rem;
  color: #9ca3af;
}
 .search-input {
  flex: 1;
  padding: 0.75rem;
  border: none;
  font-size: 0.875rem;
  color: #374151;
  min-width: 150px;
}

.search-input:focus {
  outline: none;
}

.search-button {
  padding: 0.75rem 1.25rem;
  background: #3b82f6;
  color: white;
  border: none;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.search-button:hover {
  background: #2563eb;
}

.toolbar-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}


          .toolbar-right {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            flex-wrap: wrap;
          }

       .action-button {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.875rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  text-decoration: none;
}

.action-button.secondary {
  background: #10b981;
  color: white;
}

.action-button.secondary:hover {
  background: #059669;
}
          .action-button.primary {
            background: #3b82f6;
            color: white;
          }

          .action-button.primary:hover {
            background: #2563eb;
          }

        

       .action-button.warning {
  background: #f59e0b;
  color: white;
}

.action-button.warning:hover {
  background: #d97706;
}

.action-button.info {
  background: #0ea5e9;
  color: white;
}

.action-button.info:hover {
  background: #0284c7;
}

.action-button.success {
  background: #10b981;
  color: white;
}

.action-button.success:hover {
  background: #059669;
}
         

          .action-button.select-all {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #e5e7eb;
}

.action-button.select-all:hover {
  background: #e5e7eb;
}

.action-button.view-paper {
  background: #8b5cf6;
  color: white;
}

.action-button.view-paper:hover {
  background: #7c3aed;
}
          /* Questions List */
          .questions-list {
            display: flex;
            flex-direction: column;
            gap: 1rem;
          }

          /* Question Card */
          .question-card {
            background: white;
            border-radius: 1rem;
            border: 1px solid #e2e8f0;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
            padding: 1.5rem;
            transition: all 0.3s;
          }

          .question-card:hover {
            box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
            border-color: #cbd5e0;
          }

          .question-card.picked {
            border-color: #10b981;
            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
          }

          .question-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 1rem;
          }

          .question-info {
            display: flex;
            align-items: center;
            gap: 1rem;
          }

          .question-number {
            font-size: 1.125rem;
            font-weight: 700;
            color: #3b82f6;
            background: #eff6ff;
            padding: 0.25rem 0.75rem;
            border-radius: 0.5rem;
            display: inline-block;
            width: fit-content;
          }

          .question-id {
            font-size: 0.875rem;
            color: #6b7280;
            font-weight: 500;
          }

          .question-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 0.5rem;
          }

          .tag {
            padding: 0.25rem 0.75rem;
            border-radius: 999px;
            font-size: 0.75rem;
            font-weight: 600;
          }

          .tag.level {
            background: #fef3c7;
            color: #92400e;
          }

          .tag.exam-type {
            background: #e0f2fe;
            color: #0369a1;
          }

          .tag.status {
            background: #d1fae5;
            color: #065f46;
          }

          .question-actions {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .question-checkbox {
            width: 1.25rem;
            height: 1.25rem;
            cursor: pointer;
          }

          .action-icon {
            display: flex;
            align-items: center;
            gap: 0.25rem;
            padding: 0.5rem 0.75rem;
            border: none;
            border-radius: 0.5rem;
            font-size: 0.75rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
          }

          .action-icon.pick {
            background: #3b82f6;
            color: white;
          }

          .action-icon.pick:hover {
            background: #2563eb;
          }

          .action-icon.remove {
            background: #ef4444;
            color: white;
          }

          .action-icon.remove:hover {
            background: #dc2626;
          }

          /* Question Content */
          .question-content {
            font-size: 0.9375rem;
            line-height: 1.6;
            color: #1f2937;
            margin-bottom: 1.5rem;
          }

          /* Options Section */
          .options-section {
            margin-bottom: 1.5rem;
          }

          .options-header {
            font-size: 0.875rem;
            font-weight: 600;
            color: #374151;
            margin-bottom: 0.75rem;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .options-grid {
            display: grid;
            gap: 0.75rem;
          }

          .option-item {
            display: flex;
            gap: 0.75rem;
            padding: 0.875rem;
            background: #f9fafb;
            border-radius: 0.5rem;
            border: 1px solid #e5e7eb;
          }

          .option-letter {
            width: 1.5rem;
            height: 1.5rem;
            background: #e5e7eb;
            color: #374151;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 700;
            font-size: 0.75rem;
            flex-shrink: 0;
          }

          .option-text {
            font-size: 0.875rem;
            line-height: 1.5;
            color: #1f2937;
            flex: 1;
          }

          /* Question Footer */
          .question-footer {
            border-top: 1px solid #f3f4f6;
            padding-top: 1rem;
            display: flex;
            justify-content: flex-end;
          }

          .toggle-answer {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.5rem 1rem;
            background: #3b82f6;
            color: white;
            border: none;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
          }

          .toggle-answer:hover {
            background: #2563eb;
          }

          /* Answer Section */
          .answer-section {
            margin-top: 1.5rem;
            padding-top: 1.5rem;
            border-top: 1px dashed #e5e7eb;
          }

          .answer-divider {
            height: 1px;
            background: linear-gradient(90deg, transparent, #e5e7eb, transparent);
            margin-bottom: 1.5rem;
          }

          .answer-content {
            display: flex;
            flex-direction: column;
            gap: 1rem;
          }

          .answer-field {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
          }

          .answer-field strong {
            font-size: 0.875rem;
            color: #374151;
          }

          .answer-text {
            font-size: 0.875rem;
            line-height: 1.6;
            color: #4b5563;
            padding: 0.75rem;
            background: #f9fafb;
            border-radius: 0.5rem;
            border: 1px solid #f3f4f6;
          }

          .option-id {
            font-weight: 600;
            color: #3b82f6;
          }

          /* Pagination */
          .pagination-container {
            display: flex;
            justify-content: center;
            margin: 2rem 0;
          }

          .pagination {
            display: flex;
            gap: 0.5rem;
            flex-wrap: wrap;
          }

          .pagination-button {
            padding: 0.5rem 1rem;
            border: 1px solid #e5e7eb;
            background: white;
            border-radius: 0.5rem;
            color: #374151;
            font-size: 0.875rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          }

          .pagination-button:hover {
            background: #f3f4f6;
          }

          .pagination-button.active {
            background: #3b82f6;
            color: white;
            border-color: #3b82f6;
          }

          .pagination-button:disabled {
            cursor: default;
            background: white;
            color: #374151;
          }

          /* Loading States */
          .loading-state {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 400px;
            text-align: center;
          }

          .loading-spinner {
            width: 40px;
            height: 40px;
            border: 3px solid #e0f2fe;
            border-top: 3px solid #0369a1;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin-bottom: 1rem;
          }

          @keyframes spin {
            to { transform: rotate(360deg); }
          }

          /* Empty States */
          .empty-state {
            text-align: center;
            padding: 4rem 2rem;
            color: #6b7280;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1rem;
            background: white;
            border-radius: 1rem;
            border: 1px solid #e2e8f0;
          }

          .empty-state h3 {
            font-size: 1.25rem;
            font-weight: 600;
            color: #374151;
            margin: 0;
          }

          .empty-state p {
            font-size: 0.875rem;
            margin: 0;
          }

          /* Modal */
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
            backdrop-filter: blur(3px);
          }

          .modal-container {
            background: white;
            border-radius: 1rem;
            width: 90%;
            max-width: 800px;
            max-height: 80vh;
            overflow: hidden;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
          }

          .modal-header {
            padding: 1.5rem;
            border-bottom: 1px solid #f3f4f6;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .modal-header h3 {
            font-size: 1.25rem;
            font-weight: 600;
            color: #1f2937;
            margin: 0;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .modal-close {
            background: none;
            border: none;
            font-size: 1.5rem;
            color: #9ca3af;
            cursor: pointer;
            padding: 0;
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
          }

          .modal-close:hover {
            background: #f3f4f6;
          }

          .modal-content {
            max-height: 400px;
            overflow-y: auto;
            padding: 1.5rem;
          }

          .empty-modal {
            text-align: center;
            padding: 3rem;
            color: #6b7280;
          }

          .preview-list {
            display: flex;
            flex-direction: column;
            gap: 1rem;
          }

          .preview-item {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 1rem;
            background: #f9fafb;
            border-radius: 0.75rem;
            border: 1px solid #f3f4f6;
          }

          .preview-content {
            flex: 1;
          }

          .preview-header {
            display: flex;
            gap: 1rem;
            margin-bottom: 0.5rem;
          }

          .preview-number {
            font-weight: 600;
            color: #3b82f6;
          }

          .preview-id {
            font-size: 0.75rem;
            color: #6b7280;
          }

          .preview-section {
            font-size: 0.75rem;
            color: #10b981;
            font-weight: 600;
          }

          .preview-text {
            font-size: 0.875rem;
            color: #4b5563;
            line-height: 1.5;
          }

          .preview-remove {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.5rem 0.75rem;
            background: #ef4444;
            color: white;
            border: none;
            border-radius: 0.5rem;
            font-size: 0.75rem;
            font-weight: 600;
            cursor: pointer;
          }

          .preview-remove:hover {
            background: #dc2626;
          }

          .modal-footer {
            padding: 1.5rem;
            border-top: 1px solid #f3f4f6;
            display: flex;
            justify-content: flex-end;
            gap: 0.75rem;
          }

          .modal-button {
            padding: 0.75rem 1.5rem;
            border: none;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
          }

          .modal-button.primary {
            background: #3b82f6;
            color: white;
          }

          .modal-button.primary:hover {
            background: #2563eb;
          }

          .modal-button.secondary {
            background: #f3f4f6;
            color: #374151;
            border: 1px solid #e5e7eb;
          }

          .modal-button.secondary:hover {
            background: #e5e7eb;
          }

          /* Responsive Design */
          @media (max-width: 1024px) {
            .pick-questions-content-grid {
              grid-template-columns: 1fr;
            }
            
            .filters-sidebar {
              position: fixed;
              top: 0;
              left: -280px;
              width: 280px;
              height: 100vh;
              background: white;
              z-index: 1000;
              transition: left 0.3s;
              box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);
            }
            
            .filters-sidebar.show {
              left: 0;
            }
            
            .filter-toggle {
              display: flex;
            }
            
            .close-filters {
              display: flex;
            }

             .toolbar-controls {
    gap: 0.75rem;
  }
  
  .action-button {
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
  }
          }

          @media (max-width: 768px) {
            .pick-questions-container {
              padding: 1rem;
            }
            
            .questions-toolbar {
    flex-direction: column;
    align-items: stretch;
    padding: 0.875rem;
  }

  .filter-toggle {
    align-self: flex-start;
  }
  
  .toolbar-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }
  
  .search-container {
    max-width: none;
    order: 1;
  }
  
  .toolbar-actions {
    order: 2;
    justify-content: center;
    gap: 0.5rem;
  }
  
  .action-button {
    flex: 1;
    justify-content: center;
    min-width: 80px;
  }
            .toolbar-left, .toolbar-right {
              width: 100%;
            }
            
            .toolbar-right {
              justify-content: center;
            }
            
            .search-container {
              max-width: none;
            }
            
            .options-grid {
              grid-template-columns: 1fr;
            }
          }

          @media (max-width: 480px) {
            .action-button {
              padding: 0.5rem 0.75rem;
              font-size: 0.75rem;
            }
            
            .question-header {
              flex-direction: column;
              align-items: flex-start;
              gap: 1rem;
            }
            
            .question-actions {
              width: 100%;
              justify-content: flex-end;
            }
            
            .modal-container {
              width: 95%;
              margin: 1rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default PickQuestions;